// type:'date'/'dateTime' 칸의 날짜 값을 안전하게 Date 객체로 바꿔주는 순수 함수들.
// ResponsiveDataGrid.js 가 쓰는데, 별도 파일로 뺀 이유는 ResponsiveDataGrid.js가 gridPrefStore를
// 거쳐 axios(lib/api/client)까지 끌고 들어와서 이 순수 로직만 단위테스트하기 어렵기 때문이다.
//
// MUI X가 valueGetter 없는 date/dateTime 칸은 셀 값이 Date 객체여야 한다고 기대한다 - 백엔드가
// 날짜 "문자열"(또는 LocalDate/LocalDateTime 배열 직렬화)을 그대로 내려주면 내부 포맷터가 터져
// 그리드 전체가 빈 화면으로 크래시한다(2026-10-20 점검: 수금관리/수금&지급 관리, 콘솔 "MUI X: date
// column type only accepts Date objects as values").

export const toSafeDate = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (Array.isArray(value)) {
    // [year, month(1-based), day, hour, minute, second, nano] - LocalDate/LocalDateTime 배열 직렬화 대비
    const [y, m, d, h, mi, s] = value;
    if (typeof y !== 'number') return null;
    const date = new Date(y, (m ?? 1) - 1, d ?? 1, h ?? 0, mi ?? 0, s ?? 0);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

// 이미 컨테이너가 valueGetter를 정의해 둔 칸은 손대지 않는다(건드리면 기존 동작이 바뀔 수 있음).
export const withSafeDateValueGetter = (columns) => (columns || []).map((c) => {
  if ((c.type === 'date' || c.type === 'dateTime') && typeof c.valueGetter !== 'function') {
    return { ...c, valueGetter: (value) => toSafeDate(value) };
  }
  return c;
});
